import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DepartmentService } from '../department.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DisplayModes } from '../../../models/enums';
import { ItemFormat } from '../../../models/lookups/itemFormat.model';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from '../../../services/app-translation.service';

@Component({
  selector: 'crm-add-department',
  templateUrl: './add-department.component.html',
  styleUrls: ['./add-department.component.css']
})
export class AddDepartmentComponent implements OnInit {

  displayMode: DisplayModes = DisplayModes.Success;
  department: any = {};

  @Output() closeEvent = new EventEmitter<boolean>();
  @Input() departmentId: number;
  constructor(private readonly departmentService: DepartmentService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly translateService: AppTranslationService,
    private readonly alertService: AlertService) { }

  ngOnInit() {
    if (this.departmentId != undefined)
      this.getDepartment(this.departmentId);
  }

  getDepartment(departmentId) {
    this.displayMode = DisplayModes.Loading;
    this.departmentService.getById(departmentId).subscribe(responce => {
      this.displayMode = DisplayModes.Success;
      this.department = responce as any;
    },
      err => {
        this.displayMode = DisplayModes.Error;
        console.log('error in get item fromat');
        console.log(err);
      });
  }

  save(form) {
    if (!form.invalid) {

      this.displayMode = DisplayModes.Loading;

      this.alertService.startLoadingMessage("", this.translateService.getTranslation("Saving"));
      this.departmentService.save(this.department).subscribe(() => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Success;
        this.back();
        this.alertService.showMessage("", this.translateService.getTranslation("clm.savedSuccessfully"), MessageSeverity.Success);
      }, () => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Error;
      });
    }
  }

  back() {
    this.closeEvent.emit(true);
  }


}
